export default function WhatIsSection() {
  return (
    <section id="what-is" className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">
              What Is Basetao Spreadsheet?
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              <p>
                <strong className="text-foreground-900">Basetao Spreadsheet</strong> is a structured resource system designed to help shoppers organize product discoveries, compare options, review quality information, and make smarter purchasing decisions when using the Basetao shopping agent platform.
              </p>
              <p>
                Instead of searching through thousands of random links across forums and social media, users can explore carefully categorized <strong className="text-foreground-900">Basetao spreadsheet</strong> collections covering products, reviews, QC information, shipping details, and comprehensive shopping guides &mdash; all organized in one accessible resource hub.
              </p>
              <p>
                Whether you are hunting for the latest sneaker finds, comparing luxury style replicas, or learning how to navigate international shipping, a well-maintained <strong className="text-foreground-900">Basetao spreadsheet</strong> saves hours of research time and helps you avoid common beginner mistakes.
              </p>
            </div>
          </div>
          <div className="flex-1 w-full">
            <div className="rounded-lg overflow-hidden bg-background-200/70 aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20product%20photography%20of%20stylish%20sneakers%20and%20hoodie%20on%20wooden%20desk%20surface%2C%20warm%20natural%20sunlight%2C%20minimalist%20aesthetic%2C%20cream%20and%20beige%20backdrop%2C%20editorial%20fashion%20flatlay%2C%20soft%20shadows%2C%20elegant%20composition&width=800&height=600&seq=what-is-v2&orientation=landscape&nocache=true"
                alt="Basetao Spreadsheet product resources organized on desk"
                className="w-full h-full object-cover"
                title="Basetao Spreadsheet organized resource system"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}